import { toAdminAssessmentSearchQuery } from '@hb/react'
import {
  ASSESSMENT_SNIPPETS,
  AssessmentInterface,
  AssessmentSnippet,
  AssessmentStage,
  BaseQuery,
  CollectionFilter,
  SortKey,
  getCoverageNextActionsCount,
  pregnancyStageFilterFields,
} from '@hb/shared'
import { DataListTab } from '../../../types'
import { assessmentColumns } from '../../DataList'
import {
  getAssessmentBackgroundColor,
  getAssessmentDarkBackgroundColor,
  getPresetAssessmentFilters,
  nextActionSort,
} from './common'
import { AssessmentSearchTip } from './search'

const getAdminAssessmentFilters = (stage: AssessmentStage | null, archived: boolean) => {
  const filters: CollectionFilter<AssessmentInterface>[] = []
  if (stage) {
    filters.push([pregnancyStageFilterFields[stage] as SortKey<AssessmentInterface>, '==', true])
  }
  filters.push(['archived', '==', archived])
  return filters
}

const getAssessmentSnippetBaseQuery = (
  stage: AssessmentStage | null,
  archived: boolean,
): BaseQuery<AssessmentInterface> => ({
  collection: ASSESSMENT_SNIPPETS,
  filters: getAdminAssessmentFilters(stage, archived),
})

const getAdminRowHeight = (data: AssessmentInterface) => {
  const baseHeight = data.assessmentName && !data.assessmentName.startsWith('EDD:') ? 45 : 40
  if (data.isGynProfile) return baseHeight
  return Math.max(baseHeight, getCoverageNextActionsCount(data as AssessmentSnippet) * 40)
}

export const getAdminAssessmentTab = (
  // baseTab: DataListTab<AssessmentInterface>,
  stage: AssessmentStage | null,
  archived: boolean,
  // superAdmin?: boolean,
): DataListTab<AssessmentInterface> => ({
  // ...baseTab,
  baseQuery: getAssessmentSnippetBaseQuery(stage, archived),
  itemName: 'Pregnancy',
  searchStringPath: 'stringified',
  toSearchQuery: toAdminAssessmentSearchQuery,
  searchTip: AssessmentSearchTip,
  // itemHeight: midwifeId ? 30 : 36,
  // secondarySort: secondaryNextActionSort,
  // collection: midwifeId ? getPracticeAssessmentCollectionPath(midwifeId) : baseTab.collection,
  defaultSort: nextActionSort,
  itemHeight: getAdminRowHeight,
  presetFilters: getPresetAssessmentFilters(),
  getItemBackgroundColor: getAssessmentBackgroundColor,
  getItemDarkBackgroundColor: getAssessmentDarkBackgroundColor,
  columns: assessmentColumns,
  tabBackgroundColor: archived ? 'red.100' : undefined,
  tabTextColor: archived ? 'red.800' : undefined,
  activeTabBackgroundColor: archived ? 'red.400' : undefined,
  activeTabTextColor: archived ? 'white' : undefined,
  activeTabShadow: archived,
})
